import { render, staticRenderFns } from "./PessoaInterfaceDetalhes.vue?vue&type=template&id=cc8321c8"
import script from "./PessoaInterfaceDetalhes.vue?vue&type=script&lang=js"
export * from "./PessoaInterfaceDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports